<!-- This component is used to create either an image or a video on the page -->
<template>
    <img
        v-if="type === `Image` && showImage"
        :src="url"
        :alt="alt ? alt : false"
        @click="mediaClicked"
        @focus="mediaFocus"
        @keyup="mediaKeyup"
        @contextmenu="mediaRightClick"
        @keydown="mediaKeyDown"
    />
    <video
        v-else-if="type === `Video`"
        :alt="alt ? alt : false"
        controls
        controlslist="nodownload"
        disablepictureinpicture
        @click="mediaClicked"
        @focus="mediaFocus"
        @contextmenu="mediaRightClick"
        :data-extension="extension"
    >
        <source :src="url" type="video/mp4" />
        <source :src="url" type="audio/mpeg" />
        <p>
            {{ this.$store.getters.textResource(`rs_browser_support`) }}
            <a
                :href="url"
            >{{ this.$store.getters.textResource(`rs_video_link`) }}</a>
        </p>
    </video>
    <div class="video-container" v-else-if="type === `YouTube`">
        <iframe
            :src="`https://www.youtube.com/embed/${videoId}`"
            frameborder="0"
            allow="fullscreen"
            allowfullscreen
        ></iframe>
    </div>
    <div class="video-container" v-else-if="type === `Vimeo`">
        <iframe
            :src="`https://player.vimeo.com/video/${videoId}`"
            frameborder="0"
            allow="fullscreen"
            allowfullscreen
        ></iframe>
    </div>
</template>

<script>
export default {
    name: `visual-media`,
    props: {
        url: {
            type: String,
            default: `invalidurl.png`,
        },
        alt: {
            type: String,
            default: ``,
        },
        type: {
            type: String,
            default: `image`,
        },
        extension: {
            type: String,
            default: ``,
        },
        showImage: {
            type: Boolean,
            default: true,
        },
        videoId: {
            type: String,
        },
    },
    methods: {
        mediaClicked: function (e) {
            this.$emit(`element-clicked`, e);
        },
        mediaRightClick: function (e) {
            // prevent user from using right click menu to download the video.
            e.preventDefault();
        },
        mediaFocus: function (e) {
            // Give parent elements the possibility to trigger events when this element is focused on
            this.$emit(`element-focused`, e);
        },
        mediaKeyup: function (e) {
            this.$emit(`element-keyup`, e);
        },
        mediaKeyDown: function (e) {
            // Prevent scrolling down when selecting a image with keyboard
            if (e.code === `Space`) {
                e.preventDefault();
            }

            this.$emit(`element-keydown`, e);
        },
    },
};
</script>

<style lang="scss" scoped>
video {
    width: 100%;
    max-width: 700px;
    margin: 5px auto;
    max-height: 500px;

    &[data-extension="mp3"] {
        height: 60px;
    }
}

.video-container {
    position: relative;
    overflow: hidden;
    width: 100%;
    padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

.video-container iframe,
.video-container object,
.video-container embed {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
}

[disabled] {
    filter: grayscale(1);
    cursor: default !important; // Important because disabled has to overwrite other stuff
    pointer-events: none !important;
    transition: 0.5s ease-out !important;
}

img {
    max-width: 100%;
    margin: 5px 0;
}
</style>